<template>
  <v-app-bar
    id="main-app-bar"
    app
    :dense="state.dense"
    :color="state.color"
    :prominent="state.prominent"
    style="position: relative !important;"
  >
  <!-- <v-app-bar
    :dense="state.dense"
    :color="state.color"
    shrink-on-scroll
    :prominent="state.prominent"
  > -->
    <v-btn icon @click="backBtn()" :disabled="state.backTo === '$disable'" v-if="mobile">
      <v-icon>
        mdi-arrow-left
      </v-icon>
    </v-btn>
    <v-app-bar-nav-icon v-if="showDrawerBtn" @click="toggleDrawer()"></v-app-bar-nav-icon>
    <v-btn icon to="/">
      <v-icon>
        mdi-home
      </v-icon>
    </v-btn>
    <v-toolbar-title>{{state.title}}</v-toolbar-title>

    <v-spacer></v-spacer>

    <template v-for="btn in state.sideBtns">
      <v-btn :key="btn.key" :icon="btn.icon && !btn.text" @click="onItemClick(btn, $event)">
        <v-icon v-if="btn.icon">{{btn.icon}}</v-icon>
        <span v-text="btn.text"></span>
      </v-btn>
    </template>
    <!-- 顯示當前登入的用戶名稱 -->
    <v-btn v-if="user" to="/home/userInfo">
      {{user.name}}
    </v-btn>
    <v-btn v-if="!user" to="/home/login">
      登入
    </v-btn>
    <!-- 右上角的選單 -->
    <v-menu
      left
      bottom
    >
      <template v-slot:activator="{ on }">
        <!-- 選單的按鈕 -->
        <v-btn icon v-on="on" :disabled="state.options.length === 0">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="option in state.options"
          :key="option.key"
          @click="onOptionClick(option, $event)"
        >
          <v-list-item-title>{{ option.text || option.key }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    user(){
      return this.$store.state.user.profile
    },
    assistantHeaderHeight(){
      return this.$store.state.assistantHeaderHeight
    },
    topMargin(){
      return this.$store.state.topMargin
    },
    state(){
      return this.$store.state.appbar
    },
    showDrawerBtn(){
      return this.$store.state.appbar.drawer.toggleBtn
    },
    mobile(){
      return this.$md.mobile()
    }
  },
  watch: {
    // $route: {
    //   immediate: true,
    //   handler: function(to, from){
    //     this.$store.commit('appbar/backTo')
    //     this.$store.commit('appbar/setOptions', [])
    //     console.debug('reset appbar')
    //   }
    // }
  },
  mounted(){
    this.$router.beforeEach((to, from, next) => {
      this.$store.commit('appbar/backTo')
      this.$store.commit('appbar/setOptions', [])
      this.$store.commit('appbar/clearDraer')
      console.debug('reset appbar')
      next()
    })
  },
  methods: {
    toggleDrawer(){
      this.$store.commit('appbar/toggleDrawer')
    },
    backBtn(){
      if(this.state.backTo){
        this.$router.replace(this.state.backTo)
      }else{
        this.$router.back()
      }
    },
    onItemClick(btn, event){
      if(this.$dev){
        console.log('bus: appbar-item-click', btn, event)
      }
      this.$bus.$emit('appbar-item-click', btn, event)
    },
    onOptionClick(option, event){
      if(this.$dev){
        console.log('bus: appbar-option-click', option, event)
      }
      this.$bus.$emit('appbar-option-click', option, event)
    }
  }
}
</script>

<style scoped>
  #main-app-bar{
    position: relative !important;
  }
</style>
